import type { ViewerImage } from '../components/ImageViewerProvider';

/**
 * Convert raw message media URLs (Twilio / Supabase storage / blob) into
 * ViewerImage[] for the global image viewer. Twilio URLs are routed through the
 * authenticated media proxy edge function; everything else is used directly.
 */
export function mediaUrlsToViewerImages(urls: string[], businessId?: string): ViewerImage[] {
  return (urls || []).map((mediaUrl, idx) => {
    const isTwilioUrl = mediaUrl.includes('api.twilio.com');
    const mediaId = mediaUrl.split('/Media/')[1]?.split('/')[0] || `image-${idx + 1}`;
    const download = `photo-${mediaId}.jpg`;
    if (isTwilioUrl && businessId) {
      const mediaPath = mediaUrl.replace('https://api.twilio.com', '');
      const proxy = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/twilio-media-proxy?path=${encodeURIComponent(mediaPath)}&businessId=${businessId}`;
      return { proxy, download };
    }
    return { src: mediaUrl, download };
  });
}
